import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'
import cx from 'classnames'
import { Link } from '@paper-monster/web/src/components/common'
import WebAppLink from '@paper-monster/web/src/components/common/WebAppLink'
import headerLogoImg from '@paper-monster/web/src/assets/header-logo.svg'

import TryFreeCta from '@/components/TryFreeCta'
import routes from '@/routes'

import styles from './Header.module.scss'

// No product or learn menu: the logo, Sign In and the trial CTA at every width.
export default function Header({ logoOnly, className }) {
  return (
    <div className={cx(styles.header, className)}>
      <div className={styles.content}>
        <Link className={styles.logo} to={routes.index}>
          <Image
            alt="Neat"
            height={24}
            src={headerLogoImg}
            style={{ maxWidth: '140px' }}
            width={92}
          />
        </Link>
        {logoOnly ||
        <div className={styles.nav}>
          <WebAppLink
            eventTrackingProperties={{ location: 'App Header' }}
            round={false}
            variant="secondary"
          />
          <TryFreeCta
            data-testid="header-try-neat-free"
            messageId="cta.tryNeatFREE"
            round={false}
            size="medium"
          />
        </div>}
      </div>
    </div>
  )
}

Header.propTypes = {
  logoOnly: PropTypes.bool,
  className: PropTypes.string,
}
